import Vue from 'vue';
import moment from 'moment'

Vue.filter('formatDateFull', function(value) {
    if (value) {
        return moment(value).format('LL')
    }
});
Vue.filter('formatDateShort', function(value) {
    if (value) {
        return moment(value).format('L')
    }
});
